export default "__VITE_ASSET__B0HaSK_i__"